const head = '/hzbtenderagentzero';

export default {
    fileUrl: '/standalonfile',
    ageUrl: head,
    mngUrl: head,
    bidUrl: head,
}
